/**
 * Legacy registration records for WSG ESG Group Meeting 2025 - Europe
 */

import { LegacyRegistrationRecord, LegacyRegistrationUpdateRecord } from './WSGIBAAnnualNetworkingLuncheon2025';

export const WSGESGGroupMeeting2025EuropeRecords: LegacyRegistrationRecord[] = [
  { recid: 29784, regcontactid: 587, regcompid: 307, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Václav Rovenský", regemail: "vrovensky@ksb.cz", regorganization: "Kocian Solc Balastik", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-05-23 05:45:50.050", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29794, regcontactid: 23565, regcompid: 9812, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Andras Szecskay", regemail: "andras.szecskay@szecskay.com", regorganization: "Szecskay Attorneys at Law", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-06-02 13:09:31.333", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29791, regcontactid: 23919, regcompid: 9812, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Judit Budai", regemail: "judit.budai@szecskay.com", regorganization: "Szecskay Attorneys at Law", regpaytype: "wire", regpaid: 0, regcomments: null, regcreated: "2025-06-02 00:22:56.977", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29796, regcontactid: 27899, regcompid: 9219, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Andreas Zahradnik", regemail: "andreas.zahradnik@dorda.at", regorganization: "DORDA", regpaytype: "", regpaid: 0, regcomments: null, regcreated: "2025-06-03 04:04:16.800", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29300, regcontactid: 31099, regcompid: 10092, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Alessandra Ferroni", regemail: "aferroni@gop.it", regorganization: "Gianni & Origoni", regpaytype: "cc", regpaid: 1, regcomments: "Transfer paid registration fee to Giovanni Marsili", regcreated: "2024-12-16 12:40:26.567", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29526, regcontactid: 32851, regcompid: 10092, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Giovanni Marsili", regemail: "gmarsili@gop.it", regorganization: "Gianni & Origoni", regpaytype: "cc", regpaid: 1, regcomments: "Transfer paid registration fee from Alessandra Ferroni", regcreated: "2025-03-17 19:51:23.167", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29792, regcontactid: 41722, regcompid: 9215, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Guido Hoffmann, LL.M.", regemail: "g.hoffmann@heuking.de", regorganization: "Heuking", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-06-02 10:03:50.393", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29543, regcontactid: 50992, regcompid: 10436, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Anne de Boer, LL.M. (RSA)", regemail: "a.deboer@heuking.de", regorganization: "Heuking", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-03-21 03:33:34.330", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29816, regcontactid: 52858, regcompid: 289, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Miroslav Zatko", regemail: "miroslav.zatko@cechova.sk", regorganization: "Cechova & Partners", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-06-12 16:14:21.920", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29774, regcontactid: 53399, regcompid: 9365, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Lisette Bieleveld", regemail: "bieleveld@vandoorne.com", regorganization: "Van Doorne", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-05-20 10:42:06.743", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29636, regcontactid: 55302, regcompid: 173, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Borislav Notovsky", regemail: "b.notovsky@boyanov.com", regorganization: "Boyanov & Co.", regpaytype: "wire", regpaid: 1, regcomments: null, regcreated: "2025-04-17 04:03:07.883", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29548, regcontactid: 58102, regcompid: 10141, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Angus Evers", regemail: "angus.evers@shoosmiths.com", regorganization: "Shoosmiths LLP", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-03-21 18:53:26.997", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29695, regcontactid: 68226, regcompid: 2008, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Corina Dumitru", regemail: "corina.dumitru@nndkp.ro", regorganization: "Nestor Nestor Diculescu Kingston Petersen", regpaytype: "wire", regpaid: 1, regcomments: null, regcreated: "2025-04-29 07:07:42.430", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29580, regcontactid: 81147, regcompid: 2843, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Jill Shaw", regemail: "jishaw@algoodbody.com", regorganization: "A&L Goodbody LLP", regpaytype: "cc", regpaid: 1, regcomments: null, regcreated: "2025-03-31 10:05:59.543", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29732, regcontactid: 82042, regcompid: 10698, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Iris Pensa", regemail: "iris.pensa@jadek-pensa.si", regorganization: "Jadek & Pensa", regpaytype: "wire", regpaid: 1, regcomments: null, regcreated: "2025-05-13 07:19:55.983", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29807, regcontactid: 86583, regcompid: 9219, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Marie Sophie Reitinger", regemail: "marie-sophie.reitinger@dorda.at", regorganization: "DORDA", regpaytype: "", regpaid: 0, regcomments: null, regcreated: "2025-06-11 02:44:17.503", rbadge: null, rguest1: null, rdietary: null },
  { recid: 29806, regcontactid: 86584, regcompid: 9219, regevent: "WSG ESG Group Meeting 2025 - Europe", regname: "Ayo-Victor Hübl", regemail: "ayo-victor.huebl@dorda.at", regorganization: "DORDA", regpaytype: "", regpaid: 0, regcomments: null, regcreated: "2025-06-10 12:52:19.860", rbadge: null, rguest1: null, rdietary: null },
];

/**
 * Records for updating existing registrations with explicit amount paid and payment status
 * These records are specifically for editing/updating payment information
 */
export const WSGESGGroupMeeting2025EuropeUpdateRecords: LegacyRegistrationUpdateRecord[] = [
  // Unpaid records (amountPaid: 0)
  { 
    recid: 29807, 
    regcontactid: 86583, 
    regcompid: 9219, 
    regevent: "WSG ESG Group Meeting 2025 - Europe", 
    regname: "Marie Sophie Reitinger", 
    regemail: "marie-sophie.reitinger@dorda.at", 
    regorganization: "DORDA", 
    regpaytype: "", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-06-11 02:44:17.503", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 0,
    paymentStatus: 'pending'
  },
  { 
    recid: 29806, 
    regcontactid: 86584, 
    regcompid: 9219, 
    regevent: "WSG ESG Group Meeting 2025 - Europe", 
    regname: "Ayo-Victor Hübl", 
    regemail: "ayo-victor.huebl@dorda.at", 
    regorganization: "DORDA", 
    regpaytype: "", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-06-10 12:52:19.860", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 0,
    paymentStatus: 'pending'
  },
  { 
    recid: 29796, 
    regcontactid: 27899, 
    regcompid: 9219, 
    regevent: "WSG ESG Group Meeting 2025 - Europe", 
    regname: "Andreas Zahradnik", 
    regemail: "andreas.zahradnik@dorda.at", 
    regorganization: "DORDA", 
    regpaytype: "", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-06-03 04:04:16.800", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 0,
    paymentStatus: 'pending'
  },
  { 
    recid: 29791, 
    regcontactid: 23919, 
    regcompid: 9812, 
    regevent: "WSG ESG Group Meeting 2025 - Europe", 
    regname: "Judit Budai", 
    regemail: "judit.budai@szecskay.com", 
    regorganization: "Szecskay Attorneys at Law", 
    regpaytype: "wire", 
    regpaid: 0, 
    regcomments: null, 
    regcreated: "2025-06-02 00:22:56.977", 
    rbadge: null, 
    rguest1: null, 
    rdietary: null,
    amountPaid: 0,
    paymentStatus: 'pending'
  },
];
